import { DebugLogger } from '@affine/debug';

export const logger = new DebugLogger('WorkspaceEmbedding');
